import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from "@heroicons/react/24/outline";
import {
  UserPlusIcon,
  PencilIcon,
  ArrowDownIcon,
} from "@heroicons/react/24/solid";
import {
  Dialog,
  Card,
  CardHeader,
  Input,
  Typography,
  Button,
  CardBody,
  Chip,
  CardFooter,
  IconButton,
  Tooltip,
  Select,
  Option,
} from "@material-tailwind/react";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import {
  createClientRole,
  getClientRoleData,
  updateRole,
} from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import { Checkbox } from "@mui/material";
import ExcelJS from "exceljs";
import TableRowWithShowMore from "../../components/TableRowWithShowMore";
import { useNavigate } from "react-router-dom";

const TABLE_HEAD_DATA = [
  "Page",
  "Create",
  "Read",
  "Update",
  "Delete",
  "Select All",
];
const TABLE_HEAD = ["Name", "Description", "Status", "Action"];
const TABLE_ROWS = [
  {
    name: "User",
    rolePermission: {
      userAdd: true,
      userList: true,
      userEdit: true,
      userDel: true,
      selectAll: true,
    },
  },
  {
    name: "Role",
    rolePermission: {
      roleAdd: true,
      roleList: true,
      roleEdit: true,
      roleDel: true,
      selectAll: true,
    },
  },
  {
    name: "Project",
    rolePermission: {
      projectAdd: true,
      projectList: true,
      projectEdit: true,
      projectDel: true,
      selectAll: true,
    },
  },
  {
    name: "Program",
    rolePermission: {
      programAdd: true,
      programList: true,
      programEdit: true,
      programDel: true,
      selectAll: true,
    },
  },
  {
    name: "Program Request",
    rolePermission: {
      programReqAdd: true,
      programReqList: true,
      programReqEdit: true,
      programReqDel: true,
      selectAll: true,
    },
  },
  {
    name: "Control",
    rolePermission: {
      controlAdd: true,
      controlList: true,
      controlEdit: true,
      controlDel: true,
      selectAll: true,
    },
  },
  {
    name: "Evidence",
    rolePermission: {
      evidenceAdd: true,
      evidenceList: true,
      evidenceEdit: true,
      evidenceDel: true,
      selectAll: true,
    },
  },
  {
    name: "Evidence Task",
    rolePermission: {
      evidencetaskAdd: true,
      evidencetaskList: true,
      evidencetaskEdit: true,
      evidencetaskDel: true,
      selectAll: true,
    },
  },
  {
    name: "Scans",
    rolePermission: {
      scanAdd: true,
      scanList: true,
      scanEdit: true,
      scanDel: true,
      selectAll: true,
    },
  },
  {
    name: "Scans Plugin",
    rolePermission: {
      scanPluginAdd: true,
      scanPluginList: true,
      scanPluginEdit: true,
      scanPluginDel: true,
      selectAll: true,
    },
  },
  {
    name: "Template",
    rolePermission: {
      templateAdd: true,
      templateList: true,
      templateEdit: true,
      templateDel: true,
      selectAll: true,
    },
  },
  {
    name: "Policy",
    rolePermission: {
      policyAdd: true,
      policyList: true,
      policyEdit: true,
      policyDel: true,
      selectAll: true,
    },
  },
  {
    name: "Vendor",
    rolePermission: {
      vendorAdd: true,
      vendorList: true,
      vendorEdit: true,
      vendorDel: true,
      selectAll: true,
    },
  },
  {
    name: "Vendor Questionnaire",
    rolePermission: {
      vendorQuestionnaireAdd: true,
      vendorQuestionnaireList: true,
      vendorQuestionnaireEdit: true,
      vendorQuestionnaireDel: true,
      selectAll: true,
    },
  },
  {
    name: "People",
    rolePermission: {
      peopleAdd: true,
      peopleList: true,
      peopleEdit: true,
      peopleDel: true,
      selectAll: true,
    },
  },
  {
    name: "Training",
    rolePermission: {
      trainingAdd: true,
      trainingList: true,
      trainingEdit: true,
      trainingDel: true,
      selectAll: true,
    },
  },
  {
    name: "Audit",
    rolePermission: {
      auditAdd: true,
      auditList: true,
      auditEdit: true,
      auditDel: true,
      selectAll: true,
    },
  },
  {
    name: "Integration",
    rolePermission: {
      integrationAdd: true,
      integrationList: true,
      integrationEdit: true,
      integrationDel: true,
      selectAll: true,
    },
  },
  {
    name: "Service",
    rolePermission: {
      serviceAdd: true,
      serviceList: true,
      serviceEdit: true,
      serviceDel: true,
      selectAll: true,
    },
  },
  {
    name: "Standard",
    rolePermission: {
      standardAdd: true,
      standardList: true,
      standardEdit: true,
      standardDel: true,
      selectAll: true,
    },
  },
  {
    name: "Status",
    rolePermission: {
      userAdd: true,
      userList: true,
      userEdit: true,
      userDel: true,
      selectAll: true,
    },
  },
];
export default function RolesPage() {
  const { refreshToken, rbac } = useAuthUserToken();
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const [isLoading, setIsLoading] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [reloadData, setReloadData] = useState(false);
  const [id, setId] = useState("");
  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [errors, setErrors] = useState({ name: "" });
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [open, setOpen] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  // Excel Doc
  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Roles Data");
    const headers = ["S.No.", "Role Name", "Status"];
    worksheet.addRow(headers);
    templateData.forEach((row, index) => {
      worksheet.addRow([index + 1, row.roleName, row.roleStatus]);
    });
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "roles_data.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  const handleOpenCreateDialog = () => {
    setOpenCreateDialog((cur) => !cur);
  };
  const handleOpen = (item) => {
    setFormData(item);
    setId(item?._id);
    setOpen((cur) => !cur);
  };

  const handleSelectAll = () => {
    const updatedCheckboxes = {};
    const newFormData = {
      ...formData,
      rolePermission: { ...formData.rolePermission },
    };

    TABLE_ROWS.forEach((row, rowIndex) => {
      updatedCheckboxes[rowIndex] = {};
      Object.keys(row.rolePermission).forEach((permissionName) => {
        updatedCheckboxes[rowIndex][permissionName] = true;
        newFormData.rolePermission[permissionName] = true;
      });
    });

    setSelectedCheckboxes(updatedCheckboxes);
    setFormData(newFormData);
  };

  const handleDeselectAll = () => {
    const updatedCheckboxes = {};
    const newFormData = {
      ...formData,
      rolePermission: { ...formData.rolePermission },
    };

    TABLE_ROWS.forEach((row, rowIndex) => {
      updatedCheckboxes[rowIndex] = {};
      Object.keys(row.rolePermission).forEach((permissionName) => {
        updatedCheckboxes[rowIndex][permissionName] = false;
        newFormData.rolePermission[permissionName] = false;
      });
    });

    setSelectedCheckboxes(updatedCheckboxes);
    setFormData(newFormData);
  };

  const handleCheckboxChange = (rowIndex, permissionName, colIndex, event) => {
    const updatedCheckboxes = { ...selectedCheckboxes };
    const isChecked = event.target.checked;

    if (colIndex === 4) {
      const newFormData = {
        ...formData,
        rolePermission: { ...formData.rolePermission },
      };

      Object.keys(TABLE_ROWS[rowIndex].rolePermission).forEach((key) => {
        updatedCheckboxes[rowIndex] = {
          ...updatedCheckboxes[rowIndex],
          [key]: isChecked,
        };
        newFormData.rolePermission[key] = isChecked;
      });

      setFormData(newFormData);
    } else {
      setFormData((prevFormData) => {
        return {
          ...prevFormData,
          rolePermission: {
            ...prevFormData.rolePermission,
            [permissionName]: isChecked,
          },
        };
      });

      updatedCheckboxes[rowIndex] = {
        ...updatedCheckboxes[rowIndex],
        [permissionName]: isChecked,
      };
    }

    setSelectedCheckboxes(updatedCheckboxes);
  };

  const handleChangeSelect = (e, fieldName) => {
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: e,
    }));
  };

  // On Page Load
  useEffect(() => {
    getClientRoleData(refreshToken, searchBy, sortBy, limit, page, status).then(
      (data) => {
        if (data?.code === 403) {
          navigate('/403');
          toast.error(data?.message, {
            className: "text-[12px]",
          });
        }
        if (data?.code === 440)
          toast.error(data?.message, {
            className: "text-[12px]",
          });
        setTotalPage(data?.totalPages);
        setTemplateData(data?.data?.results);
        setIsLoading(false);
      }
    );
  }, [page, limit, sortBy, searchBy, status, reloadData]);
  // End On Page Load

  // Create Form Functionality
  const [formData, setFormData] = useState({
    roleName: "",
    roleStatus: "",
    roleDescription: "",
    rolePermission: {
      userAdd: false,
      userEdit: false,
      userList: false,
      userDel: false,

      roleAdd: false,
      roleEdit: false,
      roleList: false,
      roleDel: false,

      projectAdd: false,
      projectEdit: false,
      projectList: false,
      projectDel: false,

      programAdd: false,
      programEdit: false,
      programList: false,
      programDel: false,

      programReqAdd: false,
      programReqEdit: false,
      programReqList: false,
      programReqDel: false,

      controlAdd: false,
      controlEdit: false,
      controlList: false,
      controlDel: false,

      evidenceAdd: false,
      evidenceEdit: false,
      evidenceList: false,
      evidenceDel: false,

      evidencetaskAdd: false,
      evidencetaskEdit: false,
      evidencetaskList: false,
      evidencetaskDel: false,

      scanAdd: false,
      scanEdit: false,
      scanList: false,
      scanDel: false,

      scanPluginAdd: false,
      scanPluginEdit: false,
      scanPluginList: false,
      scanPluginDel: false,

      templateAdd: false,
      templateEdit: false,
      templateList: false,
      templateDel: false,

      policyAdd: false,
      policyEdit: false,
      policyList: false,
      policyDel: false,

      vendorAdd: false,
      vendorEdit: false,
      vendorList: false,
      vendorDel: false,

      vendorQuestionnaireAdd: false,
      vendorQuestionnaireEdit: false,
      vendorQuestionnaireList: false,
      vendorQuestionnaireDel: false,

      peopleAdd: false,
      peopleEdit: false,
      peopleList: false,
      peopleDel: false,

      trainingAdd: false,
      trainingEdit: false,
      trainingList: false,
      trainingDel: false,

      auditAdd: false,
      auditEdit: false,
      auditList: false,
      auditDel: false,

      integrationDel: false,
      integrationAdd: false,
      integrationEdit: false,
      integrationList: false,

      serviceAdd: false,
      serviceEdit: false,
      serviceList: false,
      serviceDel: false,

      standardAdd: false,
      standardEdit: false,
      standardList: false,
      standardDel: false,
    },
  });

  const validateForm = () => {
    const newErrors = {};
    if (!formData?.roleName?.trim())
      newErrors.roleName = "Role name is required";
    if (!formData?.roleStatus?.trim())
      newErrors.roleStatus = "Role Status is required";
    if (!formData?.roleDescription?.trim())
      newErrors.roleDescription = "Role description is required";
    setErrors(newErrors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleBlur = () => {
    validateForm();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingButton(true);
    validateForm();
    if (Object.keys(errors).length === 0) {
      createClientRole(formData, refreshToken)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success(response?.message, {
              className: "text-[12px]",
            });
          } else if (response.code === 400 || response.code === 401) {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setIsLoadingButton(false);
          setReloadData((cur) => !cur);
          setOpenCreateDialog((cur) => !cur);
        });
    } else {
      setIsLoadingButton(false);
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setIsLoadingButton(true);
    validateForm();
    if (Object.keys(errors).length === 0) {
      updateRole(id, formData, refreshToken)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success("Role updated successfully", {
              className: "text-[12px]",
            });
          } else if (response.code === 400 || response.code === 401) {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setIsLoadingButton(false);
          setReloadData((cur) => !cur);
          setOpen((cur) => !cur);
        });
    } else {
      setIsLoadingButton(false);
    }
  };
  // End Create Form Functionality
  return (
    <div className="app-main__inner !pl-20 ">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                List of Roles
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View all default and custom roles and permissions
              </Typography>
            </div>
            <div className="flex flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              <Button
                variant="outlined"
                size="sm"
                onClick={exportToExcel}
                loading={isLoading === null ? true : false}
              >
                <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
              </Button>
              {rbac?.roleAdd ? (
                <>
                  <Button
                    onClick={handleOpenCreateDialog}
                    loading={isLoading === null ? true : false}
                    className="flex items-center gap-3"
                    size="sm"
                  >
                    <UserPlusIcon strokeWidth={2} className="h-4 w-4" />{" "}
                    <span className="hidden md:inline-block"> Create New</span>
                  </Button>
                </>
              ) : null}
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              <Select
                color="blue"
                className="!border-t-0 !border-[#b0bec5]"
                label="Select Limit"
                onChange={(event) => {
                  setLimit(event);
                  setIsLoading(null);
                }}
                value={limit}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
                <Option value={40}>40</Option>
                <Option value={50}>50</Option>
              </Select>
              <Select
                color="purple"
                className="!border-t-0 !border-[#b0bec5]"
                label="Sort By"
                value={sortBy}
                onChange={(event) => {
                  setSortBy(event);
                  setIsLoading(null);
                }}
              >
                <Option value="asc">Ascending</Option>
                <Option value="desc">Descending</Option>
              </Select>
              <Select
                color="green"
                className="!border-t-0 !border-[#b0bec5]"
                animate={{
                  mount: { y: 0 },
                  unmount: { y: 25 },
                }}
                label="Status"
                value={status}
                onChange={(event) => {
                  setStatus(event);
                  setIsLoading(null);
                }}
              >
                <Option value="">All Data</Option>
                <Option value="active">Active</Option>
                <Option value="inactive">Inactive</Option>
              </Select>
            </div>
            <div className="w-full md:w-auto">
              <Input
                label="Search"
                className="focus:!border-black focus:!border-2 focus:!border-t-0"
                value={searchBy}
                onChange={(e) => setSearchBy(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
              />
            </div>
          </div>
        </CardHeader>
        <CardBody className="overflow-scroll px-3 p-0">
          <table className="mt-4 w-full min-w-max table-auto text-left">
            <thead>
              <tr>
                {TABLE_HEAD.map((head, index) => (
                  <th
                    key={head}
                    className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-32"
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                    >
                      {head}
                      {index !== TABLE_HEAD.length - 1 && (
                        <ChevronUpDownIcon
                          strokeWidth={2}
                          className="h-4 w-4"
                        />
                      )}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            {isLoading === null ? (
              <>
                <tbody>
                  <tr>
                    <td colSpan={TABLE_HEAD.length}>
                      <TableSkeleton />
                    </td>
                  </tr>
                </tbody>
              </>
            ) : (
              <>
                <tbody>
                  {isLoading === false && templateData?.length > 0 ? (
                    templateData.map(
                      (
                        {
                          roleName,
                          roleStatus,
                          roleDescription,
                          rolePermission,
                          _id,
                        },
                        index
                      ) => {
                        const isLast = index === templateData.length - 1;
                        const classes = isLast
                          ? "p-3"
                          : "p-3 border-b border-blue-gray-50";

                        return (
                          <tr key={`${_id}-${index}`}>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {roleName}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {roleDescription?.length > 40 ? (
                                  <TableRowWithShowMore
                                    data={roleDescription}
                                  />
                                ) : (
                                  roleDescription
                                )}
                              </Typography>
                            </td>

                            <td className={classes}>
                              <div className="w-max">
                                <Chip
                                  variant="ghost"
                                  size="sm"
                                  value={
                                    roleStatus === "active"
                                      ? "Active"
                                      : "Inactive"
                                  }
                                  disabled={
                                    roleStatus === "active" ? false : true
                                  }
                                  color={
                                    roleStatus === "active" ? "green" : "red"
                                  }
                                />
                              </div>
                            </td>
                            {rbac?.roleEdit ? (
                              <>
                                <td className={classes}>
                                  <Tooltip
                                    className="bg-blue-gray-500"
                                    content="Edit"
                                  >
                                    <IconButton
                                      variant="text"
                                      onClick={() =>
                                        handleOpen({
                                          roleName,
                                          roleStatus,
                                          roleDescription,
                                          rolePermission,
                                          _id,
                                        })
                                      }
                                    >
                                      <PencilIcon className="h-4 w-4" />
                                    </IconButton>
                                  </Tooltip>
                                </td>
                              </>
                            ) : null}
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <tr>
                      <td colSpan="8">
                        <div className="flex flex-col items-center w-full">
                          <img
                            quality={100}
                            src="/assets/images/9276430.jpg"
                            className="w-[350px] mix-blend-darken"
                            alt="no-data-found"
                          />
                          <p className="text-[20px] font-medium">
                            No Data Found!
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </>
            )}
          </table>
        </CardBody>
        {isLoading === null ? null : (
          <>
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setIsLoading(null);
                  setPage(page - 1);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Previous
              </Button>
              <div className="flex items-center gap-2">
                {Array.from({ length: totalPage }, (_, index) => (
                  <IconButton
                    key={index + 1}
                    variant={index + 1 === page ? "outlined" : "text"}
                    size="sm"
                    onClick={() => {
                      setIsLoading(null);
                      setPage(index + 1);
                    }}
                    disabled={totalPage > 1 ? false : true}
                  >
                    {index + 1}
                  </IconButton>
                )).reduce((acc, button, index, array) => {
                  if (
                    totalPage > 4 &&
                    (index === 1 || index === array.length - 2)
                  ) {
                    acc.push(
                      <IconButton
                        key={`ellipsis-${index}`}
                        variant="text"
                        size="sm"
                        disabled
                      >
                        ...
                      </IconButton>
                    );
                  } else {
                    acc.push(button);
                  }
                  return acc;
                }, [])}
              </div>
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page + 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Next
              </Button>
            </CardFooter>
          </>
        )}
      </Card>

      {/* Edit Role Box */}
      <Dialog
        size="lg"
        open={open}
        handler={handleOpen}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleEdit}>
          <Card className="h-full w-full overflow-scroll">
            <CardBody className="flex flex-col gap-2 overflow-y-auto max-h-96">
              <Typography variant="h4" color="blue-gray">
                Edit | Role Management
              </Typography>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Input
                    type="text"
                    label="Name"
                    size="lg"
                    name="roleName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={formData?.roleName}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                </div>
                <div>
                  <Select
                    label="Role Status"
                    onChange={(e) => handleChangeSelect(e, "roleStatus")}
                    onBlur={handleBlur}
                    value={formData?.roleStatus}
                    name="roleStatus"
                    color="purple"
                  >
                    <Option value="">Select Status</Option>
                    <Option value="active">Active</Option>
                    <Option value="inactive">Inactive</Option>
                  </Select>
                  {errors.roleStatus && (
                    <p className="text-red-900 text-[12px]">
                      {errors.roleStatus}
                    </p>
                  )}
                </div>
              </div>
              <div>
                <Input
                  type="text"
                  label="Description"
                  size="lg"
                  name="roleDescription"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={formData?.roleDescription}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
              </div>
              <div className="flex justify-end items-center">
                <span>
                  <Button
                    variant="text"
                    type="button"
                    color="blue-gray"
                    onClick={handleSelectAll}
                  >
                    Select All
                  </Button>
                </span>
                <span className="text-blue-gray-500 font-semibold">|</span>
                <span>
                  <Button
                    variant="text"
                    color="blue-gray"
                    onClick={handleDeselectAll}
                  >
                    Deselect All
                  </Button>
                </span>
              </div>
              <table className="w-full min-w-max table-auto text-left">
                <thead>
                  <tr>
                    {TABLE_HEAD_DATA.map((head) => (
                      <th
                        key={head}
                        className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                      >
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal leading-none opacity-70"
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {TABLE_ROWS.map(({ name, rolePermission }, rowIndex) => (
                    <tr
                      key={name}
                      className={`even:bg-blue-gray-50/50 row-${rowIndex}`}
                    >
                      <td className="p-4">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {name}
                        </Typography>
                      </td>
                      {Object.entries(rolePermission).map(
                        ([permissionName, permissionValue], colIndex) => (
                          <td key={permissionName} className="p-4">
                            <Checkbox
                              id={`${rowIndex}-${permissionName}`}
                              name={permissionName}
                              label={`Checkbox ${rowIndex}-${permissionName}`}
                              ripple={true}
                              checked={
                                formData?.rolePermission?.[permissionName] ||
                                false
                              }
                              onChange={(e) =>
                                handleCheckboxChange(
                                  rowIndex,
                                  permissionName,
                                  colIndex,
                                  e
                                )
                              }
                              className="checkbox"
                            />
                          </td>
                        )
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              <Button
                variant="text"
                color="red"
                onClick={handleOpen}
                className="mr-1"
              >
                <span>Cancel</span>
              </Button>
              <Button
                type="submit"
                loading={isLoadingButton ? true : false}
                variant="gradient"
                color="green"
              >
                <span>Update</span>
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Dialog>
      {/* End Edit Role Box */}

      {/* Add Role Management  */}
      <Dialog
        size="xl"
        open={openCreateDialog}
        handler={() => setOpenCreateDialog(false)}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Card className="h-full w-full overflow-scroll">
            <CardBody className="flex flex-col gap-2 overflow-y-auto max-h-96">
              <Typography variant="h4" color="blue-gray">
                Add | Role Management
              </Typography>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Input
                    type="text"
                    label="Role Name"
                    size="lg"
                    name="roleName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.roleName && (
                    <p className="text-red-900 text-[12px]">
                      {errors.roleName}
                    </p>
                  )}
                </div>
                <div>
                  <Select
                    label="Role Status"
                    onChange={(e) => handleChangeSelect(e, "roleStatus")}
                    onBlur={handleBlur}
                    name="roleStatus"
                    color="purple"
                  >
                    <Option value="">Select Status</Option>
                    <Option value="active">Active</Option>
                    <Option value="inactive">Inactive</Option>
                  </Select>
                  {errors.roleStatus && (
                    <p className="text-red-900 text-[12px]">
                      {errors.roleStatus}
                    </p>
                  )}
                </div>
              </div>
              <div>
                <Input
                  type="text"
                  label="Role Description"
                  size="lg"
                  name="roleDescription"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
                {errors.roleDescription && (
                  <p className="text-red-900 text-[12px]">
                    {errors.roleDescription}
                  </p>
                )}
              </div>
              <div className="flex justify-end items-center">
                <span>
                  <Button
                    variant="text"
                    type="button"
                    color="blue-gray"
                    onClick={handleSelectAll}
                  >
                    Select All
                  </Button>
                </span>
                <span className="text-blue-gray-500 font-semibold">|</span>
                <span>
                  <Button
                    variant="text"
                    color="blue-gray"
                    onClick={handleDeselectAll}
                  >
                    Deselect All
                  </Button>
                </span>
              </div>

              <table className="w-full min-w-max table-auto text-left">
                <thead>
                  <tr>
                    {TABLE_HEAD_DATA.map((head) => (
                      <th
                        key={head}
                        className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                      >
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal leading-none opacity-70"
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {TABLE_ROWS.map(({ name, rolePermission }, rowIndex) => (
                    <tr
                      key={name}
                      className={`even:bg-blue-gray-50/50 row-${rowIndex}`}
                    >
                      <td className="p-4">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {name}
                        </Typography>
                      </td>
                      {Object.entries(rolePermission).map(
                        ([permissionName, permissionValue], colIndex) => (
                          <td key={permissionName} className="p-4">
                            <Checkbox
                              id={`${rowIndex}-${permissionName}`}
                              name={permissionName}
                              label={`Checkbox ${rowIndex}-${permissionName}`}
                              ripple={true}
                              checked={
                                selectedCheckboxes[rowIndex]?.[
                                permissionName
                                ] || false
                              }
                              onChange={(e) =>
                                handleCheckboxChange(
                                  rowIndex,
                                  permissionName,
                                  colIndex,
                                  e
                                )
                              }
                              className="checkbox"
                            />
                          </td>
                        )
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              <Button
                variant="text"
                color="red"
                onClick={handleOpenCreateDialog}
                className="mr-1"
              >
                <span>Cancel</span>
              </Button>
              <Button
                type="submit"
                loading={isLoadingButton ? true : false}
                variant="gradient"
                color="green"
              >
                <span>Create</span>
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Dialog>
      {/* End Add Role Management  */}
    </div>
  );
}
